define('RecipesAndEvents.Collection', [
    'RecipesAndEvents.Model',
    'Utils',
    'Backbone.CachedCollection'
], function RecipesAndEventsCollection(
    RecipesAndEventsModel,
    Utils,
    CachedCollection
) {
    'use strict';

    return CachedCollection.extend({
        url: Utils.getAbsoluteUrl(getExtensionAssetsPath('services/RecipesAndEvents.Service.ss')),
        model: RecipesAndEventsModel
    });
});
